<template>
  <div class="inner-div">
    <VasionSchedulersPage title="Retention" />
  </div>
</template>
<script>
export default {
  name: 'Retention',
}
</script>
<style lang="scss" scoped>

  .inner-div {
    padding-top: 8px;
    margin-right: 8px;
  }

</style>
